import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeSession, popPendingPaidEmail, rememberEmail } from "@/lib/api";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// This component handles the `#session_id=<id>` fragment that Emergent Auth appends
// to the redirect URL after Google sign-in.
export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const session_id = match ? decodeURIComponent(match[1]) : null;
    if (!session_id) {
      navigate("/", { replace: true });
      return;
    }
    const pending_paid_email = popPendingPaidEmail();

    (async () => {
      try {
        const res = await exchangeSession(session_id, pending_paid_email);
        rememberEmail(res.email);
        // Clean the hash so a refresh doesn't try to re-exchange a used session_id.
        window.history.replaceState(null, "", window.location.pathname);
        toast.success("Signed in");
        navigate("/watch", { replace: true });
      } catch (err) {
        const msg = err?.response?.data?.detail || "Sign-in failed";
        toast.error(msg);
        navigate("/", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div
      data-testid="auth-callback"
      className="min-h-screen flex items-center justify-center text-[#A1A1AA] font-body text-xs tracking-[0.2em] uppercase"
    >
      Signing you in…
    </div>
  );
}
